/* tslint:disable */
/* eslint-disable */
/**
 * TOM YARD SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { CreateBlockAccessPointRequest } from '../model'
// @ts-ignore
import type { CreateBlockAccessPointResponse } from '../model'
// @ts-ignore
import type { DeleteBlockAccessPointRequest } from '../model'
// @ts-ignore
import type { UpdateBlockAccessPointRequest } from '../model'
/**
 * BlockAccessPointsApi - axios parameter creator
 */
export const BlockAccessPointsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {DeleteBlockAccessPointRequest} [deleteBlockAccessPointRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    _delete: async (
      deleteBlockAccessPointRequest?: DeleteBlockAccessPointRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/BlockAccessPoints`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteBlockAccessPointRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {CreateBlockAccessPointRequest} [createBlockAccessPointRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    create: async (
      createBlockAccessPointRequest?: CreateBlockAccessPointRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/BlockAccessPoints`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createBlockAccessPointRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {UpdateBlockAccessPointRequest} [updateBlockAccessPointRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    update: async (
      updateBlockAccessPointRequest?: UpdateBlockAccessPointRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/BlockAccessPoints`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateBlockAccessPointRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * BlockAccessPointsApi - functional programming interface
 */
export const BlockAccessPointsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = BlockAccessPointsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {DeleteBlockAccessPointRequest} [deleteBlockAccessPointRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async _delete(
      deleteBlockAccessPointRequest?: DeleteBlockAccessPointRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator._delete(
        deleteBlockAccessPointRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['BlockAccessPointsApi._delete']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {CreateBlockAccessPointRequest} [createBlockAccessPointRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async create(
      createBlockAccessPointRequest?: CreateBlockAccessPointRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateBlockAccessPointResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.create(
        createBlockAccessPointRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['BlockAccessPointsApi.create']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {UpdateBlockAccessPointRequest} [updateBlockAccessPointRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async update(
      updateBlockAccessPointRequest?: UpdateBlockAccessPointRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.update(
        updateBlockAccessPointRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['BlockAccessPointsApi.update']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * BlockAccessPointsApi - factory interface
 */
export const BlockAccessPointsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = BlockAccessPointsApiFp(configuration)
  return {
    /**
     *
     * @param {DeleteBlockAccessPointRequest} [deleteBlockAccessPointRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    _delete(
      deleteBlockAccessPointRequest?: DeleteBlockAccessPointRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        ._delete(deleteBlockAccessPointRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {CreateBlockAccessPointRequest} [createBlockAccessPointRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    create(
      createBlockAccessPointRequest?: CreateBlockAccessPointRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CreateBlockAccessPointResponse> {
      return localVarFp
        .create(createBlockAccessPointRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {UpdateBlockAccessPointRequest} [updateBlockAccessPointRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    update(
      updateBlockAccessPointRequest?: UpdateBlockAccessPointRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .update(updateBlockAccessPointRequest, options)
        .then(request => request(axios, basePath))
    },
  }
}

/**
 * BlockAccessPointsApi - object-oriented interface
 */
export class BlockAccessPointsApi extends BaseAPI {
  /**
   *
   * @param {DeleteBlockAccessPointRequest} [deleteBlockAccessPointRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public _delete(
    deleteBlockAccessPointRequest?: DeleteBlockAccessPointRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return BlockAccessPointsApiFp(this.configuration)
      ._delete(deleteBlockAccessPointRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {CreateBlockAccessPointRequest} [createBlockAccessPointRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public create(
    createBlockAccessPointRequest?: CreateBlockAccessPointRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return BlockAccessPointsApiFp(this.configuration)
      .create(createBlockAccessPointRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {UpdateBlockAccessPointRequest} [updateBlockAccessPointRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public update(
    updateBlockAccessPointRequest?: UpdateBlockAccessPointRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return BlockAccessPointsApiFp(this.configuration)
      .update(updateBlockAccessPointRequest, options)
      .then(request => request(this.axios, this.basePath))
  }
}
